export const fetchNotificationTypes = [
  'FETCH_NOTIFICATION',
  'FETCH_NOTIFICATION_SUCCESS',
  'FETCH_NOTIFICATION_FAIL',
];

export const fetchNotificationPageTypes = [
  'FETCH_NOTIFICATION_PAGE',
  'FETCH_NOTIFICATION_PAGE_SUCCESS',
  'FETCH_NOTIFICATION_PAGE_FAIL',
];

export const notificationMarkReadTypes = [
  'NOTIFICATION_MARK_READ',
  'NOTIFICATION_MARK_READ_SUCCESS',
  'NOTIFICATION_MARK_READ_FAIL',
];

export const SUBSCRIBE_TO_NOTIFICATION = 'SUBSCRIBE_TO_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/modules/notification/action_types.js